// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GenerateReadyPlanVersionNotesQueryVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
}>;


export type GenerateReadyPlanVersionNotesQuery = { __typename?: 'Query', generateReadyPlanVersionNotes: { __typename?: 'GenerateReadyPlanVersionNotesResult', notes: string } };


export const GenerateReadyPlanVersionNotesDocument = gql`
    query GenerateReadyPlanVersionNotes($readyPlanId: ID!) {
  generateReadyPlanVersionNotes(readyPlanId: $readyPlanId) {
    notes
  }
}
    `;

/**
 * __useGenerateReadyPlanVersionNotesQuery__
 *
 * To run a query within a React component, call `useGenerateReadyPlanVersionNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateReadyPlanVersionNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateReadyPlanVersionNotesQuery({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *   },
 * });
 */
export function useGenerateReadyPlanVersionNotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables> & ({ variables: GenerateReadyPlanVersionNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>(GenerateReadyPlanVersionNotesDocument, options);
      }
export function useGenerateReadyPlanVersionNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>(GenerateReadyPlanVersionNotesDocument, options);
        }
// @ts-ignore
export function useGenerateReadyPlanVersionNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>;
export function useGenerateReadyPlanVersionNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GenerateReadyPlanVersionNotesQuery | undefined, GenerateReadyPlanVersionNotesQueryVariables>;
export function useGenerateReadyPlanVersionNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>(GenerateReadyPlanVersionNotesDocument, options);
        }
export type GenerateReadyPlanVersionNotesQueryHookResult = ReturnType<typeof useGenerateReadyPlanVersionNotesQuery>;
export type GenerateReadyPlanVersionNotesLazyQueryHookResult = ReturnType<typeof useGenerateReadyPlanVersionNotesLazyQuery>;
export type GenerateReadyPlanVersionNotesSuspenseQueryHookResult = ReturnType<typeof useGenerateReadyPlanVersionNotesSuspenseQuery>;
export type GenerateReadyPlanVersionNotesQueryResult = Apollo.QueryResult<GenerateReadyPlanVersionNotesQuery, GenerateReadyPlanVersionNotesQueryVariables>;